module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo5-efa41a78391ee96b0fcfd86da1b38a2e.jpg";